export default "__VITE_ASSET__6HNWeqip__"